export default __webpack_public_path__ + "static/media/waves.b4d40945.png";